<div class="flex-container">
  <div class="flex-item">
    <mat-list>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.id' | transloco }}</span>
        <span matListItemLine>{{ order.id }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.dateRequested' | transloco }}</span>
        <span>{{ order.dateRequested | localizedDate }}</span>
      </mat-list-item>
      <mat-list-item>
        <span matListItemTitle>{{ 'common.labels.visibility' | transloco }}</span>
        <span matListItemLine>{{ order.isVisible ? 'Visible' :
          'Deleted'
        }}</span>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="flex-item">
    <mat-list class="flex-item">
      <mat-list-item>
        <span matListItemTitle>{{ criteriaHeaderKey | transloco }}</span>
        <span>{{ getSearchCriteria(order) }}</span>
      </mat-list-item>
    </mat-list>
    @if (order.jurisdiction == '_M') {
      <mat-list class="flex-item">
        <mat-list-item>
          <span matListItemTitle>{{ 'common.labels.jurisdictions' | transloco }}</span>
          <span>{{ getSearchJurisdictions(order) }}</span>
        </mat-list-item>
      </mat-list>
    }
  </div>
</div>